// extracted by mini-css-extract-plugin
var _1 = "Checkbox_checkbox__JfSNC";
var _2 = "Checkbox_checkboxError__c3fH8";
var _3 = "Checkbox_label__kSi4W";
var _4 = "Checkbox_size14__hhN+t";
var _5 = "Checkbox_size20__pz4pt";
var _6 = "Checkbox_wrapper__lntd7";
export { _1 as "checkbox", _2 as "checkboxError", _3 as "label", _4 as "size14", _5 as "size20", _6 as "wrapper" }
